<template>
  <div>
    <v-row>
      <v-col cols="8">
        <h3 class="mb-4">Добавить ТС</h3>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="searchText"
          label="Поиск ТС"
          placeholder="Введите код ТС"
          class="pt-0 mt-0"
          clearable
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredVehicles"
      :loading="loading"
      no-data-text="Нет записей"
      height="400"
      loading-text="Загрузка ТС"
      class="mb-4"
      item-key="govNum"
      fixed-header
      show-select
      disable-pagination
      hide-default-footer
    ></v-data-table>

    <v-row dense>
      <v-col>
        <v-btn
          outlined
          color="red"
          @click="cancelAdd"
        >
          Отмена
        </v-btn>
      </v-col>

      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="addVehicle"
          :disabled="selected.length === 0"
        >
          Добавить выбранные
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Vehicles',
  props: {
    items: {
      type: Array,
      required: true,
    },
    vehicles: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    selected: [],
    searchText: '',
    headers: [
      {
        text: 'Код',
        value: 'code',
      },
      {
        text: 'Гос номер',
        value: 'govNum',
      },
      {
        text: 'Дата начала учета',
        value: 'startDate',
      },
      {
        text: 'Дата окончания учета',
        value: 'endDate',
      },
    ],
  }),
  computed: {
    filteredVehicles() {
      const re = new RegExp(this.searchText, 'i');

      return this.items.filter(vehicle => {
        let index = this.vehicles.findIndex(item => {
          return item.id === vehicle.id;
        });

        if (this.searchText && !re.test(vehicle.code)) {
          return false;
        }

        return index === -1;
      });
    },
  },
  methods: {
    addVehicle() {
      this.$emit('onAdd', this.selected);

      this.selected = [];
    },
    cancelAdd() {
      this.selected = [];

      this.$emit('onCancel');
    },
  },
};
</script>
